module.exports = __webpack_public_path__ + "img/page-header-dots.f787767b.svg";